module.exports = __webpack_public_path__ + "img/samsung-galaxy-s6-edgeplus.16ff97f6.png";